import { ApiBaseUrl, GetBearerHeader } from '../api';

export interface CreateTiloGameRequest {
  name: string;
  client: string;
  gameType: string;
  nbrDoors: number;
  hideScore: boolean;
  playtime: number;
  startsAt: string;
  language: string;
  teamsCount: number;
  nbrPlayersPerTeam: number;
  locationCountryISO?: string;
}

export interface CreateTiloGameResponse {
  GAME: {
    _id: string;
    [key: string]: unknown;
  };
}

export const CreateTiloGameAsync = async (
  request: CreateTiloGameRequest
): Promise<CreateTiloGameResponse> => {
  const response = await fetch(`${ApiBaseUrl}/tilo/games`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...GetBearerHeader()
    },
    body: JSON.stringify(request)
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message ?? 'Failed to create TILO game.');
  }

  return response.json();
};

export interface TiloWorldRecord {
  name: string;
  timeWin: number;
  rank: number;
  score: number;
  win: boolean;
  timeL1: number;
  timeL2: number;
  game: {
    startedAt: string;
    name: string;
    client: string;
    gameType: string;
    nbrDoors: number;
    company: string;
    country: string;
    partner: string;
  };
}

export const GetTiloWorldRecordsAsync = async (
  doors: 8 | 12
): Promise<TiloWorldRecord[]> => {
  const response = await fetch(`${ApiBaseUrl}/tilo/world-records`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...GetBearerHeader()
    },
    body: JSON.stringify({ doors })
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message ?? 'Failed to load TILO world records.');
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

export const ArchiveTiloGameAsync = async (gameId: string): Promise<void> => {
  const response = await fetch(`${ApiBaseUrl}/tilo/games/${gameId}`, {
    method: 'DELETE',
    headers: {
      ...GetBearerHeader()
    }
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message ?? 'Failed to archive TILO game.');
  }
};